// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rRnku","label":"styles_label__3nmXD"};